<div
  class="w-full flex justify-between gap-4 lg:gap-10 flex-col lg:flex-row"
  [ngClass]="styleClass()"
>
  <section class="main_info flex items-center flex-col">
    <img
      [src]="(photoSource() | imageReader:true) | async"
      class="w-[120px] h-[120px] rounded-full object-cover"
      alt=""
    />
    <p
      class="font-semibold text-[20px] lg:text-[24px] user_fullName text-center"
    >
      {{ userData()?.fullName || 'No name provided' }}
    </p>
    @if (canChangePhoto()) {
      <div class="mt-3 flex flex-col items-center gap-2">
        <input
          #photoInput
          type="file"
          class="hidden"
          accept=".png,.jpg,.jpeg"
          (change)="onChangePhoto($event)"
        />
        <p-button
          severity="info"
          [label]="'change_photo' | transloco"
          [loading]="uploadingPhoto()"
          [disabled]="uploadingPhoto()"
          (onClick)="photoInput.click()"
        ></p-button>
        <p class="text-xs text-[#94A3B8]">
          {{ 'accept_type_picture' | transloco }}
        </p>
      </div>
    }
  </section>
  <section
    class="w-full grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4 lg:gap-4"
  >
    @for (item of showUserData; track $index) {
    <div class="grid grid-rows-[auto_1fr] items-start">
      <label for="" class="text-[#2E90FA] text-[14px] font-normal break-words"
        >{{item.label | transloco}}</label
      >
      <p class="text-[#454F4D] text-[14px] font-medium break-words">
        @if(item.value==='gender') {
        <span
          >{{(userData()?.gender===1 ? 'man' : (userData()?.gender===2 ? 'girl'
          : '-')) | transloco}}</span
        >
        } @else{ {{getDisplayValue(getValue(item.value), item.value)}} }
      </p>
    </div>
    } @if (userData()?.region?.uz) {
    <div class="grid grid-rows-[auto_1fr] items-start">
      <label for="" class="text-[#2E90FA] text-[14px] font-normal break-words"
        >{{ 'region' | transloco }}</label
      >
      <p class="text-[#454F4D] text-[14px] font-medium break-words">
        {{userData()?.region | languagePipe |async}}
      </p>
    </div>
    } @if (userData()?.district?.uz) {
    <div class="grid grid-rows-[auto_1fr] items-start">
      <label for="" class="text-[#2E90FA] text-[14px] font-normal break-words"
        >{{ 'District' | transloco }}</label
      >
      <p class="text-[#454F4D] text-[14px] font-medium break-words">
        {{userData()?.district | languagePipe |async}}
      </p>
    </div>
    } @if (userData()?.institution?.uz) {
    <div class="grid grid-rows-[auto_1fr] items-start">
      <label for="" class="text-[#2E90FA] text-[14px] font-normal break-words"
        >{{ 'institution' | transloco }}</label
      >
      <p class="text-[#454F4D] text-[14px] font-medium break-words">
        {{userData()?.institution | languagePipe |async}}
      </p>
    </div>
    }
  </section>
</div>
